export default "__VITE_ASSET__DAR12F2T__"